import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { specials } from "@/mocks/movies";
import { getMoviesByIds } from "@/lib/movies";
import { useSeo } from "@/hooks/useSeo";
import type { SpecialItem } from "@/types/movie";

const specialList = specials as unknown as SpecialItem[];

export default function Special() {
  useSeo({
    title: "影视专题 - 91免费看片",
    description:
      "91免费看片影视专题合集，涵盖年度科幻精选、悬疑烧脑、都市情感、合家欢动画等主题片单，编辑精心挑选，值得一看。",
    keywords: "影视专题,电影合集,电视剧推荐,片单,91免费看片",
  });

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <div className="rounded-xl bg-primary-600 px-6 py-8 md:px-10 md:py-10">
        <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
          <i className="ri-bookmark-3-fill" /> 编辑精选
        </span>
        <h2 className="mt-4 font-heading text-2xl font-extrabold text-background-50 md:text-3xl">
          影视专题合集
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-100/85">
          按主题、题材与情绪为你整理片单，无论是想找烧脑悬疑还是放松治愈，都能在这里快速找到合适的影视内容。
        </p>
      </div>

      <div className="mt-8 space-y-10">
        {specialList.map((sp) => {
          const items = getMoviesByIds(sp.movieIds);
          return (
            <section key={sp.id}>
              <SectionHeading
                title={sp.title}
                subtitle={sp.subtitle}
                icon="ri-movie-line"
                moreTo="/category/电影"
                moreLabel="更多"
              />
              <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                <div className="grid grid-cols-1 md:grid-cols-[320px_1fr]">
                  <div className="relative h-48 w-full md:h-full">
                    <img
                      src={sp.cover}
                      alt={`${sp.title} 专题封面`}
                      title={`${sp.title} 91免费看片`}
                      className="h-full w-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 to-transparent md:bg-gradient-to-r" />
                  </div>
                  <div className="p-5">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      <span className="font-semibold text-accent-600">推荐理由：</span>
                      {sp.reason}
                    </p>
                    <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                      {items.map((m) => (
                        <Link
                          key={m.id}
                          to={`/detail/${m.id}`}
                          className="group flex items-center gap-3 rounded-lg border border-background-200 p-2 transition-colors hover:border-primary-300 hover:bg-primary-50"
                        >
                          <img
                            src={m.poster}
                            alt={`${m.title} 海报`}
                            title={`${m.title} 91免费看片`}
                            className="h-16 w-11 shrink-0 rounded object-cover object-top"
                          />
                          <div className="min-w-0">
                            <p className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                              {m.title}
                            </p>
                            <p className="mt-0.5 truncate text-xs text-foreground-500">
                              {m.year} · {m.region}
                            </p>
                            <p className="mt-0.5 text-xs font-semibold text-accent-600">
                              {m.rating.toFixed(1)} 分
                            </p>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          );
        })}
      </div>

      <div className="mt-10 rounded-xl border border-background-200 bg-background-100 p-6 text-center">
        <h3 className="font-heading text-lg font-bold text-foreground-950">
          想看更多专题？
        </h3>
        <p className="mt-2 text-sm text-foreground-500">
          前往分类页按题材、地区与年份自由筛选，组合出属于你的专属片单。
        </p>
        <Link
          to="/category/电影"
          className="mt-4 inline-flex rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
        >
          开始筛选
        </Link>
      </div>
    </div>
  );
}